const Table = () => import('@/../../coreui/components/ServerTable')
export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null 
    || allowed.includes('Visitors'))  {
    routes =  [
      {
        name: 'VisLog', 
        path: '/VisLog', 
        component: Table, 
        props: {schema: 'sch_vis_log', table: 'vis_log'}
      }
  ] 
} 
  
  return routes
}
